<template>
  <MainLayout :title="$t('pages.datalink')" :subTitle="$t('datalink.instructions')" :displayTitle="displayTitle">
    <template slot="rightElements" />
    <div slot="content">
      <RouterView />
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/Main";

export default {
  components: {
    MainLayout,
  },
  computed: {
    displayTitle() {
      return this.$route.name !== "dataLinkDetails";
    },
  },
};
</script>
